import { IClient } from '@frontend/app/hooks';

export const buildInstagramDefaultFiltersPrompt = (client?: IClient): string => {
  const clientName = client?.name || 'a brand';
  const brandCategory = client?.brandCategory || 'other';

  return [
    `Find Instagram creators for a brand called ${clientName}, which has a brand category of ${brandCategory}.`,
    'Provide a short query, interests, and only include creators that are in the Instagram Creator Marketplace.',
    'Do not include the brand name in the query.',
  ].join('\n');
};
